import { css } from '@emotion/react'

const fullWidth = css`
  max-width: 100%;
`

const dropdownContainer = css`
  & > * {
    width: 100%;
  }
`

const dropdownBtn = css`
  min-width: 100%;
`

export const styles = {
  fullWidth,
  dropdownContainer,
  dropdownBtn,
}
